import React from 'react';
import { Button } from 'react-bootstrap';
import { useTheme } from '../../context/ThemeContext';
import { BsSun, BsMoon } from 'react-icons/bs';
import './ThemeToggle.css';

const ThemeToggle = () => {
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <Button
            variant={isDarkMode ? 'light' : 'dark'}
            onClick={toggleTheme}
            className="theme-toggle-btn ms-2"
            aria-label="Toggle theme"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            {isDarkMode ? <BsSun size={20} /> : <BsMoon size={20} />}
        </Button>
    );
};

export default ThemeToggle;